import { getPromiseTimeoutEmulator } from "../emulators/getPromiseTimeoutEmulator";

const CLIENT_ID =
    "594820501607-t0it6u7t4brqjlq61cvf1m9pv16n2o8c.apps.googleusercontent.com";
const API_KEY = "AIzaSyAqUt-C19H5-PiJtY1Nszjvwxc4ngpGcYE";
const DISCOVERY_DOCS = [
    "https://www.googleapis.com/discovery/v1/apis/tasks/v1/rest",
];
const SCOPES = "https://www.googleapis.com/auth/tasks.readonly";
const LOAD_PROMISE = window.lib_googleApiIsLoaded;
const SIGN_IN_PROMISE = window.lib_googleApi_hasSignedIn;
const TASKS_LIST_ID = "MDczNDA4ODYyMjk3Nzg4OTEyNzY6MDow";

window.lib_googleApi_signOut = () => {
    gapi.auth2.getAuthInstance().signOut();
};

const updateSigninStatus = (isSignedIn) => {
    if (isSignedIn) {
        window.lib_googleApi_hasSignedIn_resolve();
    } else {
        document.body.insertAdjacentHTML(
            "afterbegin",
            `<div class="google_tasks_button_auth_asker"><button onClick="gapi.auth2.getAuthInstance().signIn();">Auth to use google tasks API</button></div>`,
        );
    }
};

const initClient = () => {
    gapi.client
        .init({
            apiKey: API_KEY,
            clientId: CLIENT_ID,
            discoveryDocs: DISCOVERY_DOCS,
            scope: SCOPES,
        })
        .then(
            function () {
                // Listen for sign-in state changes.
                gapi.auth2
                    .getAuthInstance()
                    .isSignedIn.listen(updateSigninStatus);

                // Handle the initial sign-in state.
                updateSigninStatus(
                    gapi.auth2.getAuthInstance().isSignedIn.get(),
                );
            },
            function (error) {
                console.error(JSON.stringify(error, null, 2));
            },
        );
};

export const prepareTasksApiToUse = () => {
    LOAD_PROMISE.then(() => {
        gapi.load("client:auth2", initClient);
    });
};

const getRawTasks = async () => {
    try {
        await SIGN_IN_PROMISE;

        const tasksList = await gapi.client.tasks.tasks.list({
            tasklist: TASKS_LIST_ID,
            showCompleted: false,
            maxResults: 100,
        });

        const rawTasks = tasksList.result.items;

        return rawTasks;
    } catch (err) {
        console.error(err);
        return "error";
    }
};

export const getTasks = async () => {
    const rawTasks = await getRawTasks();

    if (rawTasks === "error") {
        return "error";
    }

    rawTasks.forEach((task) => {
        if (task.parent) {
            const parent = rawTasks.find(
                (possibleParrent) => possibleParrent.id === task.parent,
            );

            if (!parent.subtasks) {
                parent.subtasks = [];
            }

            parent.subtasks.push(task);
        }
    });

    const firstLevelTasks = rawTasks.filter((task) => !task.parent);

    firstLevelTasks.sort((a, b) => a.position - b.position);

    const firstStepCleaning = (task) => {
        const result = {
            id: task.id,
            title: task.title,
        };

        if (task.notes) {
            result.description = task.notes;
        }

        return result;
    };

    const cleanedTasks = firstLevelTasks.map((task) => {
        const result = firstStepCleaning(task);

        if (task.subtasks) {
            task.subtasks.sort((a, b) => a.position - b.position);

            result.subtasks = task.subtasks.map(firstStepCleaning);
        }

        return result;
    });

    return cleanedTasks;
};

export const postTaskComplete = async (id) => {
    await getPromiseTimeoutEmulator(500, "resolve");
    // await gapi.client.tasks.tasks.patch({
    //   tasklist: TASKS_LIST_ID,
    //   task: id,
    //   resource: {
    //     status: "completed",
    //   },
    // });
};

const awaitMs = (ms) =>
    new Promise((resolve) => {
        setTimeout(() => {
            resolve();
        }, ms);
    });

export const getCompletedTasks = async (date) => {
    try {
        // return [];

        if (new Date(date) > Date.now()) {
            return [];
        }
        await SIGN_IN_PROMISE;

        const minDate = new Date(date);
        const maxDate = new Date(date);

        minDate.setHours(0);
        minDate.setMinutes(0);
        maxDate.setHours(23);
        maxDate.setMinutes(59);

        const taskslists = await gapi.client.tasks.tasklists.list();

        const rawTasks = [];

        let resolve;
        const promise = new Promise((res) => (resolve = res));

        taskslists.result.items.forEach(async (list, index, arr) => {
            await awaitMs(Math.round(Math.random() * 2000));

            const response = await gapi.client.tasks.tasks.list({
                tasklist: list.id,
                completedMin: minDate.toISOString(),
                completedMax: maxDate.toISOString(),
                showHidden: true,
            });

            if (response.result.items) {
                response.result.items.forEach((task) => rawTasks.push(task));
            }

            if (index === arr.length - 1) {
                resolve();
            }
        });

        await promise;

        return rawTasks;
    } catch (err) {
        console.error(err);
        return [];
    }
};
